module.exports = __webpack_public_path__ + "static/media/10-mobile.d15146f4.jpg";